import React from 'react';

const fmtAmount = (n) =>
  (Number(n) || 0).toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Wyświetla informację o DOTACJI i źródłach finansowania zadania.
 * variant: "modal" – modal opisów, "print" – podgląd A4 / druk
 */
const DotacjaDisplay = ({ desc, variant = 'modal' }) => {
  if (!desc?.isDotacja) return null;

  const a = Number(desc.srodkiPowiat) || 0;
  const b = Number(desc.srodkiSpZoz) || 0;
  const hasAmounts = desc.srodkiPowiat != null || desc.srodkiSpZoz != null;

  if (variant === 'print') {
    return (
      <div className="mt-2 print:mt-1 pt-2 print:pt-1 border-t border-gray-300 print:border-t print:border-gray-200">
        <div className="text-xs print:text-[10px] text-gray-700 font-normal">
          <div className="font-bold text-purple-800 mb-1">DOTACJA (dotyczy księgowości)</div>
          {hasAmounts && (
            <>
              <div className="underline font-semibold mb-1">Źródła finansowania zadania:</div>
              <div className="pl-2 space-y-0.5">
                <div className="flex justify-between gap-4">
                  <span>- środki z Powiatu Białostockiego</span>
                  <span>{fmtAmount(a)} zł</span>
                </div>
                <div className="flex justify-between gap-4">
                  <span>- środki SP ZOZ w Łapach</span>
                  <span>{fmtAmount(b)} zł</span>
                </div>
              </div>
              <div className="flex justify-between gap-4 mt-1 pt-1 font-bold">
                <span>Wartość wydatku</span>
                <span>{fmtAmount(a + b)} zł</span>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="text-sm font-normal text-gray-700 mt-2 pt-2 border-t border-purple-200">
      <div className="font-bold text-purple-800 mb-1">DOTACJA (dotyczy księgowości)</div>
      {hasAmounts && (
        <>
          <div className="underline font-semibold mb-1">Źródła finansowania zadania:</div>
          <div className="pl-2 space-y-0.5">
            <div className="flex justify-between gap-4">
              <span>- środki z Powiatu Białostockiego</span>
              <span>{fmtAmount(a)} zł</span>
            </div>
            <div className="flex justify-between gap-4">
              <span>- środki SP ZOZ w Łapach</span>
              <span>{fmtAmount(b)} zł</span>
            </div>
          </div>
          <div className="flex justify-between gap-4 mt-1 pt-1 font-bold">
            <span>Wartość wydatku</span>
            <span>{fmtAmount(a + b)} zł</span>
          </div>
        </>
      )}
    </div>
  );
};

export const buildDotacjaHtml = (desc) => {
  if (!desc?.isDotacja) return '';

  const a = Number(desc.srodkiPowiat) || 0;
  const b = Number(desc.srodkiSpZoz) || 0;
  const hasAmounts = desc.srodkiPowiat != null || desc.srodkiSpZoz != null;
  const fmt = (n) => n.toLocaleString('pl-PL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  let html = `<div class="sig-extra sig-dotacja">
    <div class="sig-dotacja-label" style="font-weight:700;color:#6b21a8;margin-bottom:4px;">DOTACJA (dotyczy księgowości)</div>`;

  if (hasAmounts) {
    html += `<div class="sig-dotacja-header" style="text-decoration:underline;font-weight:600;margin-bottom:4px;">Źródła finansowania zadania:</div>
      <div style="padding-left:8px;">
        <div style="display:flex;justify-content:space-between;gap:16px;"><span>- środki z Powiatu Białostockiego</span><span>${fmt(a)} zł</span></div>
        <div style="display:flex;justify-content:space-between;gap:16px;"><span>- środki SP ZOZ w Łapach</span><span>${fmt(b)} zł</span></div>
      </div>
      <div style="display:flex;justify-content:space-between;gap:16px;margin-top:4px;padding-top:4px;font-weight:bold;">Wartość wydatku<span>${fmt(a + b)} zł</span></div>`;
  }

  html += '</div>';
  return html;
};

export default DotacjaDisplay;
